import React from 'react'
import styles from './AppWrapper.module.css'

type AppWrapperProps = {
  children?: React.ReactNode
  className?: string
}

class AppWrapper extends React.Component<AppWrapperProps> {
  render() {
    const buttonClasses = `${styles.wrapper} ${this.props.className || ''}`

    return (
      <div
        className={`${buttonClasses} w-full max-w-screen-md mx-auto p-5 flex flex-col gap-y-2 mt-auto`}
      >
        {this.props.children}
      </div>
    )
  }
}

export default AppWrapper
